<template>
  <v-container fluid>
    <v-tabs v-model="activeTab" class="my-5 text-none">
      <v-tab key="facturas" class="text-none"> Histórico de facturas</v-tab>

      <v-tab key="membresias" class="text-none"> Histórico de Membresías </v-tab>

      <v-tab key="eventos" class="text-none"> Histórico de cursos y eventos </v-tab>

      <v-tab key="eventPoints" v-if="isImefOrganization(user.headOffice.id)" class="text-none"> Puntos de capacitación </v-tab>

      <v-tab key="paymentPlans" v-if="isAsofomOrganization(user.headOffice.id)" class="text-none"> Pagos pendientes </v-tab>
    </v-tabs>

    <v-tabs-items v-model="activeTab">
      <v-tab-item key="facturas">
        <div class="filter-container mt-5 mx-5">
          <span class="titlehist">Histórico de facturas</span>
          <!-- barra de navegación -->
          <div class="d-flex flex-row my-4">
            <v-btn
              fab
              small
              elevation="0"
              class="rounded-pill rounded-r-0"
              color="#feb300"
            >
              <!-- @click="" -->
              <v-icon size="20">mdi-magnify</v-icon>
            </v-btn>
            <input
              type="text"
              placeholder="Buscar facturas"
              class="rounded-pill rounded-l-0"
              v-model="invoiceSearch"
            />
          </div>
          <!-- información -->
          <v-simple-table height="100%" class="mx-10">
            <thead>
              <tr>
                <th
                  v-for="(title, i) in invoiceTableTitles"
                  :key="i"
                  class="text-left"
                >
                  {{ title }}
                </th>
              </tr>
            </thead>
            <tbody>
              <template v-for="invoiceRow in invoicesFiltered">
              <tr :key="`invoice-${invoiceRow.id}`">
                <th>
                  <div>{{ invoiceRow.isPreinvoice ? 'Prefactura' : invoiceTypeLabel(invoiceRow.invoiceType) }}</div>
                  <small v-if="invoiceRow.orderId" class="grey--text">Orden #{{ String(invoiceRow.orderId).slice(-8) }}</small>
                </th>
                <th>{{ invoiceRow.description }}</th>
                <th>{{ invoiceRow.total }}</th>
                <th>{{ invoiceRow.createdAt }}</th>
                <th>
                  <v-chip
                    v-if="invoiceRow.status !== 'PAID'"
                    x-small
                    color="#ff9800"
                    class="white--text"
                  >
                    {{ invoiceStatusLabel(invoiceRow) }}
                  </v-chip>
                  <span v-else style="color: #4caf50; font-weight: 600;">Pagada</span>
                </th>
                <th>
                  <div>
                    <v-tooltip v-if="invoiceRow.isPreinvoice" bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-on="on"
                          v-bind="attrs"
                          icon
                          @click="
                            getPreinvoiceFile(invoiceRow, false)
                          "
                        >
                          <v-icon>mdi-eye</v-icon>
                        </v-btn>
                      </template>
                      <span>Visualizar prefactura</span>
                    </v-tooltip>

                    <v-tooltip v-else-if="invoiceRow.invoice" bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-on="on"
                          v-bind="attrs"
                          icon
                          @click="getInvoiceFile({ invoice: invoiceRow.invoice, download: false })"
                        >
                          <v-icon>mdi-eye</v-icon>
                        </v-btn>
                      </template>
                      <span>Visualizar CFDI</span>
                    </v-tooltip>

                    <v-tooltip v-if="invoiceRow.isPreinvoice" bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-on="on"
                          v-bind="attrs"
                          icon
                          @click="getPreinvoiceFile(invoiceRow, true)"
                        >
                          <v-icon>mdi-download</v-icon>
                        </v-btn>
                      </template>
                      <span>Descargar prefactura</span>
                    </v-tooltip>

                    <v-tooltip v-else-if="invoiceRow.invoice" bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-on="on"
                          v-bind="attrs"
                          icon
                          @click="getInvoiceFile({ invoice: invoiceRow.invoice, download: true })"
                        >
                          <v-icon>mdi-download</v-icon>
                        </v-btn>
                      </template>
                      <span>Descargar CFDI</span>
                    </v-tooltip>

                    <v-btn
                      v-if="invoiceRow.complements.length"
                      text
                      small
                      class="text-none"
                      @click="toggleInvoiceComplements(invoiceRow.id)"
                    >
                      <v-icon left small>mdi-format-list-bulleted</v-icon>
                      {{ expandedInvoiceId === invoiceRow.id ? 'Ocultar pagos' : 'Ver pagos' }}
                      ({{ invoiceRow.complements.length }})
                    </v-btn>

                    <v-btn
                      v-if="canPayInvoiceRow(invoiceRow)"
                      small
                      rounded
                      color="blue darken-2"
                      class="white--text text-capitalize ml-2"
                      @click="payInvoiceRow(invoiceRow)"
                    >
                      <v-icon small left>mdi-cash</v-icon>
                      {{ invoiceRow.order && invoiceRow.order.paymentPlan ? 'Pagar cuota' : 'Pagar' }}
                    </v-btn>
                  </div>
                </th>
              </tr>
              <tr
                v-if="expandedInvoiceId === invoiceRow.id && invoiceRow.complements.length"
                :key="`complements-${invoiceRow.id}`"
                class="complement-details-row"
              >
                <td colspan="6">
                  <div class="complement-details">
                    <strong>Desglose de parcialidades facturadas</strong>
                    <v-simple-table dense class="mt-2">
                      <thead>
                        <tr>
                          <th>Complemento</th>
                          <th>Parcialidad</th>
                          <th>Fecha</th>
                          <th>Monto</th>
                          <th>Estado</th>
                          <th>Documento</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="complement in invoiceRow.complements" :key="complement.id">
                          <td>#{{ complement.complementNumber || '—' }}</td>
                          <td>
                            Pago {{ complement.installmentNumber || '—' }}
                            de {{ (invoiceRow.order && invoiceRow.order.paymentPlan && invoiceRow.order.paymentPlan.installmentsCount) || '—' }}
                          </td>
                          <td>{{ formatComplementDate(complement.createdAt) }}</td>
                          <td>{{ formatPlanCurrency(complement.total || 0) }}</td>
                          <td>{{ complementStatusLabel(complement) }}</td>
                          <td>
                            <v-btn
                              icon
                              small
                              aria-label="Visualizar complemento de pago"
                              @click="getInvoiceFile({ invoice: complement.invoice, download: false })"
                            >
                              <v-icon small>mdi-eye</v-icon>
                            </v-btn>
                            <v-btn
                              icon
                              small
                              aria-label="Descargar complemento de pago"
                              @click="getInvoiceFile({ invoice: complement.invoice, download: true })"
                            >
                              <v-icon small>mdi-download</v-icon>
                            </v-btn>
                          </td>
                        </tr>
                      </tbody>
                    </v-simple-table>
                  </div>
                </td>
              </tr>
              </template>
            </tbody>
          </v-simple-table>
          <v-dialog
            fullscreen
            hide-overlay
            transition="dialog-bottom-transition"
            v-model="fileDialog"
          >
            <v-btn
              v-if="$vuetify.breakpoint.smAndDown != true"
              bottom
              right
              absolute
              fab
              color="accent"
              :style="{
                position: 'absolute',
                bottom: '50px',
                right: '50px',
              }"
              @click="fileDialog = false"
              ><v-icon>mdi-close</v-icon></v-btn
            >
            <v-btn v-else @click="fileDialog = false" large bottom
              ><v-icon>mdi-close</v-icon></v-btn
            >
            <iframe
              type="application/pdf"
              :src="invoiceUrl"
              style="width: 100%; height: 100%; border: none"
            ></iframe>
          </v-dialog>
        </div>
      </v-tab-item>

      <v-tab-item key="membresias">
        <!-- contenido de la pestaña "Histórico de Membresías" -->
        <div class="filter-container mt-5 mx-5">
          <span class="titlehist">Histórico de Membresías</span>
          <!-- barra de navegación -->
          <div class="searchbar d-flex flex-row my-4">
            <v-btn
              fab
              small
              elevation="0"
              class="rounded-pill rounded-r-0"
              color="#feb300"
              @click="filterItems()"
            >
              <v-icon size="20">mdi-magnify</v-icon>
            </v-btn>
            <input
              type="text"
              placeholder="Buscar en membresías"
              class="rounded-pill rounded-l-0"
              v-model="searchField"
            />
          </div>
          <!-- información -->
          <v-simple-table height="100%" class="mx-10">
            <thead>
              <tr>
                <th
                  v-for="(title, i) in tableTitles"
                  :key="i"
                  class="text-left"
                >
                  {{ title }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(cont, i) in tableContentfilt"
                :key="i"
                class="text-left"
              >
                <!-- Columna de filtros -->
                <!-- <th class="px-0"></th> -->
                <th>
                  {{ cont.name }}
                </th>
                <th>
                  {{ cont.inicio }}
                </th>
                <th>
                  {{ cont.exp == "" ? "---" : cont.exp }}
                </th>
                <th class="text-uppercase">
                  {{ cont.type }}
                </th>
                <th>
                  {{ cont.costo }}
                </th>
                <!-- <th>
                  <span
                    class="text-decoration-underline"
                    :class="cont.estado"
                  >
                    {{ cont.estado }}
                  </span>
                </th> -->
              </tr>
            </tbody>
          </v-simple-table>
        </div>
      </v-tab-item>

      <v-tab-item key="eventos">
        <div class="filter-container mt-5 mx-5">
          <span class="titlehist pb-10">Histórico de Cursos y Eventos</span>
          <!-- Barra de búsqueda para eventos -->
          <div class="searchbar d-flex flex-row my-4">
            <v-btn
              fab
              small
              elevation="0"
              class="rounded-pill rounded-r-0"
              color="#feb300"
              @click="filterEvents()"
            >
              <v-icon size="20">mdi-magnify</v-icon>
            </v-btn>
            <input
              type="text"
              placeholder="Buscar en eventos"
              class="rounded-pill rounded-l-0"
              v-model="searchField2"
            />
          </div>
          <!-- Tabla para el histórico de eventos -->
          <v-simple-table height="300px" class="mx-10 pt-1">
            <thead>
              <tr>
                <th
                  v-for="(title, i) in eventTableTitles"
                  :key="i"
                  class="text-left"
                >
                  {{ title }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(event, index) in eventTableDataFiltered"
                :key="index"
                class="text-left"
              >
              <td v-for="(item) in Object.keys(event)" :key="item">
                {{event[item]}}
              </td>
                <!-- <td>{{ event.name }}</td>
                <td>{{ event.startDate.slice(0, 10) }}</td>
                <td>{{ event.endDate.slice(0, 10) }}</td>
                <td>{{ event.price }}</td>
                <td>{{ event.membersOnlyTruePrice || 0 }}</td>
                <td>{{ event.membersOnlyFalsePrice || 0 }}</td> -->
              </tr>
            </tbody>
          </v-simple-table>
        </div>
      </v-tab-item>

      <v-tab-item key="eventPoints" v-if="isImefOrganization(user.headOffice.id)">
        <div class="filter-container mt-5 mx-5">
        <span class="titlehist">Puntos de capacitación</span>
        <div class="d-flex align-center justify-space-between">
          <p class="ml-4 mt-4" style="width: 50%">
            En este apartado podrás visualizar y descargar los puntos de capacitación para los eventos a los que has asistido.
          </p>
          <v-btn class="rounded-pill text-capitalize" style="font-weight: bold" elevation="0" :color="color.secondary" @click.prevent="postMemberPointsCertificate()">Descargar Certificado</v-btn>
        </div>
        <v-simple-table class="px-8">
          <thead>
              <tr>
                <th
                  v-for="({ value, align = 'left' }, i) in userPointsHeaders"
                  :key="i"
                  :class="`text-${align}`"
                >
                  {{ value }}
                </th>
              </tr>
            </thead>
                <tbody>
                    <tr v-for="(item, index) in userPointList" :key="index">
                        <td class="text-uppercase" style="font-weight: 700;">{{ item.event.name }}</td>
                        <td class="text-center">{{ formatDate(item.createdAt) }}</td>
                        <td class="text-end text-bold">{{ item.points }}</td>
                    </tr>
                </tbody>
            </v-simple-table>
        </div>
      </v-tab-item>

      <v-tab-item key="paymentPlans" v-if="isAsofomOrganization(user.headOffice.id)">
        <div class="filter-container mt-5 mx-5">
          <!-- ─── Órdenes Pendientes de Pago ─── -->
          <span class="titlehist">Órdenes Pendientes de Pago</span>

          <template v-if="memberPendingOrders.length > 0">
            <v-simple-table height="100%" class="mx-10 mt-4">
              <thead>
                <tr>
                  <th class="text-left">Concepto</th>
                  <th class="text-left">Tipo</th>
                  <th class="text-left">Monto / saldo</th>
                  <th class="text-left">Fecha</th>
                  <th class="text-left">Acciones</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="order in memberPendingOrders" :key="order._id">
                  <td>{{ getPendingOrderName(order) }}</td>
                  <td>
                    <v-chip x-small :color="order.event ? '#1e88e5' : '#7b1fa2'" class="white--text">
                      {{ order.event ? 'Evento' : 'Membresía' }}
                    </v-chip>
                  </td>
                  <td>
                    <div>{{ formatPlanCurrency(order.paymentPlan ? order.paymentPlan.totalAmount : (order.totalWithDiscount || order.total)) }}</div>
                    <small v-if="order.paymentPlan" class="grey--text">
                      {{ order.paymentPlan.paidInstallments || 0 }}/{{ order.paymentPlan.installmentsCount }} parcialidades · Saldo: {{ formatPlanCurrency(getPaymentPlanBalance(order.paymentPlan)) }}
                    </small>
                  </td>
                  <td>{{ formatPlanDate(order.createdAt) }}</td>
                  <td>
                    <v-btn
                      small
                      rounded
                      color="blue darken-2"
                      class="white--text text-capitalize"
                      @click="payPendingOrder(order)"
                    >
                      <v-icon small left>mdi-cash</v-icon>
                      {{ order.paymentPlan ? 'Pagar parcialidad' : 'Pagar' }}
                    </v-btn>
                  </td>
                </tr>
              </tbody>
            </v-simple-table>
          </template>
          <template v-else>
            <p class="text-body-2 mt-4 ml-10">No tienes órdenes pendientes de pago.</p>
          </template>

          <!-- ─── Planes de Pago de Eventos ─── -->
          <v-divider class="my-6"></v-divider>
          <span class="titlehist">Planes de Pago de Eventos</span>
          <div class="searchbar d-flex flex-row my-4">
            <v-btn
              fab
              small
              elevation="0"
              class="rounded-pill rounded-r-0"
              color="#feb300"
              @click="filterPaymentPlans()"
            >
              <v-icon size="20">mdi-magnify</v-icon>
            </v-btn>
            <input
              type="text"
              placeholder="Buscar por nombre de evento"
              class="rounded-pill rounded-l-0"
              v-model="paymentPlanSearch"
            />
          </div>

          <template v-if="eventPaymentPlansFiltered.length > 0">
            <v-simple-table height="100%" class="mx-10">
              <thead>
                <tr>
                  <th class="text-left">Evento</th>
                  <th class="text-left">Monto Total</th>
                  <th class="text-left">Cuotas Pagadas</th>
                  <th class="text-left">Estado</th>
                  <th class="text-left">Acciones</th>
                </tr>
              </thead>
              <tbody>
                <template v-for="plan in eventPaymentPlansFiltered">
                  <tr :key="plan._id">
                    <td>{{ plan.event ? plan.event.name : 'N/D' }}</td>
                    <td>{{ formatPlanCurrency(plan.totalAmount) }}</td>
                    <td>{{ plan.paidInstallments }} de {{ plan.installmentsCount }}</td>
                    <td>
                      <v-chip
                        x-small
                        class="white--text"
                        :color="planStatusColor(plan.status)"
                      >
                        {{ planStatusLabel(plan.status) }}
                      </v-chip>
                    </td>
                    <td>
                      <v-btn icon small @click="togglePlanDetail(plan._id)">
                        <v-icon>{{ expandedPlanId === plan._id ? 'mdi-chevron-up' : 'mdi-eye' }}</v-icon>
                      </v-btn>
                      <v-btn
                        v-if="plan.status === 'ACTIVE' && getNextPendingInstallment(plan)"
                        icon
                        small
                        color="blue darken-2"
                        @click="$router.push(`/member/partial-payment/${plan._id}`)"
                      >
                        <v-icon>mdi-cash</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                  <tr v-if="expandedPlanId === plan._id" :key="plan._id + '-detail'" :ref="'planDetail-' + plan._id">
                    <td colspan="5" class="pa-0">
                      <v-simple-table dense class="mx-6 my-2">
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>Monto</th>
                            <th>Fecha límite</th>
                            <th>Estado</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="inst in plan.installments" :key="inst._id || inst.number">
                            <td>{{ inst.number }}</td>
                            <td>{{ formatPlanCurrency(inst.amount) }}</td>
                            <td>{{ formatPlanDate(inst.dueDate) }}</td>
                            <td>
                              <v-chip
                                x-small
                                class="white--text"
                                :color="installmentColor(inst.status)"
                              >
                                {{ installmentLabel(inst.status) }}
                              </v-chip>
                            </td>
                          </tr>
                        </tbody>
                      </v-simple-table>
                    </td>
                  </tr>
                </template>
              </tbody>
            </v-simple-table>
          </template>
          <template v-else>
            <p class="text-body-2 mt-4 ml-10">No tienes planes de pago de eventos.</p>
          </template>
        </div>
      </v-tab-item>
    </v-tabs-items>
  </v-container>
</template>

<script>
import axios from "axios";
import moment from "moment";
import { colors } from '@/constants/colors.js';
import { formatPrice, downloadFile } from "@/utils";
import { formatDate } from "@/utils/dates.js";
import { mapActions, mapState, mapMutations } from "vuex";
import { isImefOrganization, isAsofomOrganization } from "../../share/imef";
import Endpoints from "@/share/Endpoints";

export default {
  data() {
    return {
      searchField: "",
      searchField2: "",
      tableTitles: ["Nombre", "Inicio", "Expiración", "Concepto", "Costo"],
      invoiceTableTitles: [
        "Id",
        "Concepto",
        "Monto",
        "Fecha de emisión",
        "Estado",
        "Acciones",
      ],
      tableContent: [],
      invoiceSearch: "",
      invoices: [],
      color: colors,
      invoicesFiltered: [],
      userPointList: [],
      userPointsHeaders: [
        { value: "Evento" },
        { value: "Fecha", align: "center"},
        { value: "Puntos", align: "right" },
      ],
      invoiceUrl: "",
      fileDialog: false,
      organizationType: {
        FIRST_PAYMENT: "Pago inicial",
        HEAD_OFFICE: "Renovación",
        BRANCH: "Membresía Local",
        INSCRIPTION: "Inscripción",
        PRODUCT_SERVICE: "Producto / Servicio",
        PARTIAL_PAYMENT: "Pago parcial",
        DEBT: "Adeudo",
      },
      statusType: {
        ACTIVE: "Activo",
        EXPIRED: "Expirado",
        INACTIVE: "Inactivo",
      },
      tableContentfilt: [],

      activeTab: "membresias",
      eventTableTitles: [],
      eventTableData: [],
      isEventDataLoaded: false,
      eventSearchField: "",
      eventTableDataFiltered: [],
      paymentPlanSearch: "",
      expandedPlanId: null,
      expandedInvoiceId: null,
    };
  },
  watch: {
    invoiceSearch(value) {
      if (value != "") {
        this.filterInvoices(value, (filter) => {
          this.invoicesFiltered = filter;
        });
      } else {
        this.invoicesFiltered = this.invoices;
      }
    },
  },
  methods: {
    ...mapActions("member", ["fetchMemberItems"]),
    ...mapActions("paymentPlan", ["fetchMemberPaymentPlans"]),
    ...mapActions("order", ["fetchMemberPendingOrders"]),
    ...mapMutations("loader", ["loading", "loaded"]),
    ...mapMutations("notification", ["show"]),
    isImefOrganization,
    isAsofomOrganization,
    filterInvoices(value, callback) {
      setTimeout(() => {
        let filt = [...this.invoices].filter((element, index) => {
          return (
            element.description.toLowerCase().includes(value.toLowerCase()) ||
            element.id.toLowerCase().includes(value.toLowerCase())
          );
        });
        callback(filt);
      }, 1500);
    },

    filterItems() {
      let ft = this.searchField;
      this.searchField = "";
      this.tableContentfilt = this.tableContent.filter((cont) => {
        return (
          cont.estado.toLowerCase().includes(ft.toLowerCase()) ||
          cont.costo.toLowerCase().includes(ft.toLowerCase()) ||
          cont.memLev.toLowerCase().includes(ft.toLowerCase())
        );
      });
    },

    formatDate(createdDate) {
            const date = new Date(createdDate);
            const day = String(date.getDate()).padStart(2, '0');
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const year = date.getFullYear();
            return `${day}/${month}/${year}`;
        },

    filterEvents() {
      const searchText = this.searchField2.toLowerCase();
      this.searchField2 = "";
      this.eventTableDataFiltered = this.eventTableData.filter((event) => {
        return (
          event.name.toLowerCase().includes(searchText) ||
          event.startDate.slice(0, 10).includes(searchText) ||
          event.endDate.slice(0, 10).includes(searchText) ||
          event.costo.includes(searchText)
        );
      });
    },

    filterPaymentPlans() {
      // triggers reactivity — the computed handles filtering
      this.paymentPlanSearch = this.paymentPlanSearch.trim();
    },

    togglePlanDetail(planId) {
      this.expandedPlanId = this.expandedPlanId === planId ? null : planId;
      if (this.expandedPlanId) {
        this.$nextTick(() => {
          const ref = this.$refs['planDetail-' + planId];
          const el = Array.isArray(ref) ? ref[0] : ref;
          if (el) {
            el.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        });
      }
    },

    getNextPendingInstallment(plan) {
      if (!plan || !Array.isArray(plan.installments)) return null;
      return plan.installments.find((i) => i.status === 'PENDING');
    },

    planStatusColor(status) {
      const map = { ACTIVE: '#1e88e5', COMPLETED: '#4caf50', CANCELLED: '#9e9e9e' };
      return map[status] || '#9e9e9e';
    },

    planStatusLabel(status) {
      const map = { ACTIVE: 'Activo', COMPLETED: 'Completado', CANCELLED: 'Cancelado' };
      return map[status] || status;
    },

    installmentColor(status) {
      const map = { PENDING: '#9e9e9e', PAID: '#4caf50', OVERDUE: '#f44336' };
      return map[status] || '#9e9e9e';
    },

    installmentLabel(status) {
      const map = { PENDING: 'Pendiente', PAID: 'Pagada', OVERDUE: 'Vencida' };
      return map[status] || status;
    },

    formatPlanCurrency(amount) {
      return new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(amount);
    },

    getPaymentPlanBalance(plan) {
      if (!Array.isArray(plan?.installments)) return Number(plan?.totalAmount || 0);
      return plan.installments.reduce((balance, installment) =>
        installment.status === 'PAID' ? balance : balance + Number(installment.amount || 0),
      0);
    },

    formatPlanDate(dateStr) {
      if (!dateStr) return 'N/D';
      return new Date(dateStr).toLocaleDateString('es-MX', { day: '2-digit', month: 'short', year: 'numeric' });
    },

    getPendingOrderName(order) {
      if (order.event) return order.event.name || 'Evento';
      if (order.affiliation) return order.affiliation.name || 'Membresía';
      return 'Orden #' + (order._id || '').slice(-6);
    },

    goToPayOrder(order) {
      if (order.event) {
        const ticketId = order.items && order.items.length > 0 ? order.items[0].ticket : null;
        if (ticketId) {
          this.$router.push({
            path: `/member/eventCheckout/${order.event._id}/${ticketId}`,
            query: { orderId: order._id },
          });
        } else {
          this.$router.push({
            path: `/member/eventCheckout/${order.event._id}`,
            query: { orderId: order._id },
          });
        }
      } else if (order.affiliation) {
        const affiliationTypeId = order.items && order.items.length > 0 ? order.items[0].affiliationType : null;
        if (affiliationTypeId) {
          this.$router.push({
            path: `/member/checkout/payment/${order.affiliation._id}/${affiliationTypeId._id || affiliationTypeId}/${this.user._id}`,
            query: { orderId: order._id },
          });
        } else {
          this.$router.push({
            path: `/member/payment/${order.affiliation._id}`,
            query: { orderId: order._id },
          });
        }
      }
    },

    payPendingOrder(order) {
      if (order.paymentPlan) {
        this.$router.push(`/member/partial-payment/${order.paymentPlan._id}`);
        return;
      }
      this.goToPayOrder(order);
    },

    formatInvoices(invoices = []) {
      return invoices.map((invoice) => ({
        ...invoice,
        id: invoice.id || invoice.invoice || invoice.orderId,
        total: formatPrice(invoice.total ?? invoice.price ?? 0),
        createdAt: formatDate(invoice.date),
        status: invoice.status || 'PAID',
        complements: invoice.complements || [],
      }));
    },

    toggleInvoiceComplements(invoiceId) {
      this.expandedInvoiceId = this.expandedInvoiceId === invoiceId ? null : invoiceId;
    },

    formatComplementDate(date) {
      return date ? new Date(date).toLocaleDateString('es-MX') : '—';
    },

    complementStatusLabel(complement) {
      return complement.invoice && complement.status === 'PAID'
        ? 'Emitido'
        : 'Pendiente';
    },

    invoiceTypeLabel(invoiceType) {
      const labels = { PPD: 'Factura PPD', INCOME: 'Factura', COMPLEMENT: 'Complemento de pago' };
      return labels[invoiceType] || 'Factura';
    },

    invoiceStatusLabel(invoiceRow) {
      if (invoiceRow.status === 'PLAN_PENDING') {
        const plan = invoiceRow.order?.paymentPlan || {};
        return `Plan pendiente · ${plan.paidInstallments || 0}/${plan.installmentsCount || 0} cuotas`;
      }
      if (invoiceRow.isPreinvoice) return 'Prefactura pendiente';
      return 'Pendiente de pago';
    },

    canPayInvoiceRow(invoiceRow) {
      const order = invoiceRow.order;
      if (!order) return false;
      const plan = order.paymentPlan;
      if (plan) return plan.status === 'ACTIVE' && !!plan.nextInstallment;
      return order.status === 'PAYMENT_PENDING';
    },

    payInvoiceRow(invoiceRow) {
      const plan = invoiceRow.order?.paymentPlan;
      if (plan) {
        this.$router.push(`/member/partial-payment/${plan._id}`);
        return;
      }
      this.goToPayOrder(invoiceRow.order);
    },

    async fetchUserInvoices() {
      try {
        this.loading();
        const response = await this.axios({
          method: "GET",
          url: "/invoices/member-invoice-paginate",
          params: {
            userId: this.user.id,
          },
        });
        if (response.status == 200) {
          this.invoices = this.formatInvoices(response.data.invoices);
          this.invoicesFiltered = this.invoices;
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loaded();
      }
    },

    async getInvoiceFile({ invoice, download = false }) {
      try {
        this.loading();
        const { status, data } = await this.axios({
          method: "POST",
          url: "/invoices/download-member-invoice",
          data: {
            invoiceId: invoice,
            organizationId: this.user.headOffice.id,
            download,
          },
          responseType: "arraybuffer",
        });
        if (status === 200) {
          if (download) {
            downloadFile(data, "application/zip", "invoice.zip");
          } else {
            let blob = new File([data], "invoice.pdf", {
              type: `application/pdf`,
            });
            const fileUrl = URL.createObjectURL(blob);
            this.invoiceUrl = fileUrl;
            this.fileDialog = true;
            console.log(fileUrl);
          }
        }
      } catch (error) {
        console.error("[getInvoiceFile] error", error);
        const action = download ? "descargar" : "previsualizar";
        const backendMessage =
          error?.response?.data?.error?.message ||
          error?.message ||
          "";
        this.show({
          text: backendMessage
            ? `No pudimos ${action} la factura: ${backendMessage}`
            : `No pudimos ${action} la factura. Inténtalo de nuevo en unos minutos.`,
          color: "error",
        });
      } finally {
        this.loaded();
      }
    },

    async getPreinvoiceFile(invoiceRow, download = false) {
      try {
        this.loading();
        const endpoint = Endpoints.invoicesMemberPreinvoicePdf.replace(/:orderId/, invoiceRow.orderId);
        const { status, data } = await this.axios({
          method: 'GET',
          url: endpoint,
          params: download ? { download: 1 } : {},
          responseType: 'arraybuffer',
        });
        if (status === 200) {
          if (download) {
            downloadFile(data, 'application/pdf', `prefactura-${String(invoiceRow.orderId).slice(-8)}.pdf`);
          } else {
            const blob = new File([data], 'prefactura.pdf', { type: 'application/pdf' });
            this.invoiceUrl = URL.createObjectURL(blob);
            this.fileDialog = true;
          }
        }
      } catch (error) {
        const message = error?.response?.data?.error?.message || 'No pudimos abrir la prefactura. Inténtalo de nuevo.';
        this.show({ text: message, color: 'error' });
      } finally {
        this.loaded();
      }
    },

    async fetchMemberEvents() {
      try {
        this.loading();
        const response = await axios.get("/members/event-orders");

        if (!response.data) {
          this.eventTableData = [];
        } else {
          console.log(response.data);
          this.eventTableData = response.data.content;
          this.eventTableTitles = response.data.headers;
          // response.data.map((event) => {
          //   const membersOnlyTruePrice =
          //     event.membersOnlyTruePrice !== undefined &&
          //     event.membersOnlyTruePrice !== 0
          //       ? "$" + event.membersOnlyTruePrice + " MXN"
          //       : "$" + event.price + " MXN";

          //   const membersOnlyFalsePrice =
          //     event.membersOnlyFalsePrice !== undefined &&
          //     event.membersOnlyFalsePrice !== 0
          //       ? "$" + event.membersOnlyFalsePrice + " MXN"
          //       : "$" + event.price + " MXN";

          //   return {
          //     price: "$" + event.price + " MXN",
          //     name: event.name,
          //     startDate: event.startDate,
          //     endDate: event.endDate,
          //     startTime: event.startTime,
          //     endTime: event.endTime,
          //     membersOnlyTruePrice,
          //     membersOnlyFalsePrice,
          //   };
          // });
        }

        this.isEventDataLoaded = true;

        this.eventTableDataFiltered = this.eventTableData;

        this.loaded();
      } catch (error) {
        console.error(error);
        this.loaded();
      }
    },

    async fetchUserPoints() {
            try {
                let response = await this.axios({
                    method: 'GET',
                    url: `/events/points/${this.user._id}`,
                });
                this.userPointList = response.data?.pointsArray || [];
            } catch (error) {
                console.log(error);
            }
        },

    async postMemberPointsCertificate() {
      this.loading();
      try {
        let response = await this.axios({
          method: 'POST',
          url: '/events/points/get-certificate',
          data: {
            memberId: this.user._id
          }
        });

        if (response.status == 200) {
          if (response.data.constancyUrl) {
            window.location.href = response.data.constancyUrl;
          }
        }
        console.log(response)
      } catch (error) {
        this.show({
          text: "Ha habido un error con la descarga de su certificado, por favor intente nuevamente",
          color: "error",
        })
      } finally {
        this.loaded();
      }
    }
  },

  computed: {
    ...mapState("member", ["items"]),
    ...mapState("user", ["user"]),
    ...mapState("paymentPlan", ["memberPaymentPlans"]),
    ...mapState("order", ["memberPendingOrders"]),

    eventPaymentPlans() {
      return this.memberPaymentPlans.filter((p) => p.event != null);
    },

    eventPaymentPlansFiltered() {
      if (!this.paymentPlanSearch) return this.eventPaymentPlans;
      const search = this.paymentPlanSearch.toLowerCase();
      return this.eventPaymentPlans.filter((p) =>
        (p.event && p.event.name || '').toLowerCase().includes(search)
      );
    },
  },

  async mounted() {
    // Llamada a la función fetchMemberEvents después de montar el componente

    // Resto de tu código en el método mounted
    if (
      this.$route &&
      this.$route.query &&
      this.$route.query.tab === "eventPoints" &&
      this.user &&
      this.user.headOffice &&
      isImefOrganization(this.user.headOffice.id)
    ) {
      this.activeTab = "eventPoints";
    }

    this.loading();
    let branch = localStorage.getItem("affiliationProfile");
    let its = {};
    let objts = {};

    if (!this.items.data) {
      its = (await this.fetchMemberItems(branch)).data.items;
    } else {
      its = this.items.data.items;
    }
    try {
      await this.fetchUserPoints();
      await this.fetchUserInvoices();
      await this.fetchMemberEvents();
      await this.fetchMemberPaymentPlans();
      await this.fetchMemberPendingOrders();

      objts = its.map((ob) => {
        console.log(ob.status);
        let item = {
          name: ob.affiliation
            ? ob.affiliation.name
            : ob.affiliationInscription
            ? ob.affiliationInscription.description
            : "",
          inicio: ob.createdAt.split("T").shift(),
          exp: "2023-05-23",
          type: this.organizationType[ob.type],
          costo: ob.total
            ? `$${ob.total} MXN`
            : ob.order
            ? `$${ob.order.total} MXN`
            : "$0 MXN",
          estado: this.statusType[ob.status],
        };

        const { affiliateInformation } = ob;

        if (affiliateInformation) {
          if (
            affiliateInformation.inactiveDate &&
            affiliateInformation.expirationDate
          ) {
            item.exp = moment(affiliateInformation.inactiveDate).format(
              "YYYY-MM-DD"
            );
          } else if (affiliateInformation.inactiveDate) {
            item.exp = moment(affiliateInformation.inactiveDate).format(
              "YYYY-MM-DD"
            );
          } else if (affiliateInformation.expirationDate) {
            item.exp = moment(affiliateInformation.inactiveDate).format(
              "YYYY-MM-DD"
            );
          }
        }
        return item;
      });
      objts.forEach((obj) => {
        this.tableContent.push(obj);
      });
      this.tableContentfilt = this.tableContent;
    } catch (error) {
      console.log(error);
    } finally {
      this.loaded();
    }
  },
};
</script>

<style scoped>
@font-face {
  font-family: "Montserrat-Black";
  src: url("/src/assets/fonts/Montserrat/MONTSERRAT_Montserrat-Black.otf")
    format("otf");
}

.titlehist {
  font-family: "Montserrat-Black", Fallback, sans-serif;
  font-weight: 800;
  font-size: 20px;
}

input::placeholder {
  font-size: 15px;
  color: #d4dcd4;
}

input {
  padding-left: 20px;
  width: 30rem;
  max-width: 30rem;
  min-width: 10rem;
  border: 0;
  border-color: transparent;
  background-color: #f9fafc;
}

input:focus {
  outline: none;
  border: 1px solid transparent;
}

th {
  font-weight: 400;
  font-size: 5px;
}

.complement-details-row > td {
  background: #f8f9fc;
  padding: 16px 24px !important;
}

.complement-details {
  border-left: 3px solid #feb300;
  padding: 4px 12px;
}

.complement-details th {
  font-size: 12px;
  font-weight: 600;
}

.complement-details td {
  font-size: 13px;
}

.Activo {
  color: #7cd6b7;
  font-weight: 600;
}

/* .Expirado {
  color: #b1b1b1;
  font-weight: 600;
}

.Inactivo {
  color: red;
  font-weight: 600
} */
</style>
